import { render, staticRenderFns } from "./ShapeForm.vue?vue&type=template&id=69d824ec&"
import script from "./ShapeForm.vue?vue&type=script&lang=js&"
export * from "./ShapeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports